export const stagingDecorationLink = `${process.env.PUBLIC_URL}/img/decoration_ref_320x213.jpg`
